import { createSlice } from "@reduxjs/toolkit";
import { assignUserPrivilegeAsync, createPrivilegeAsync, fetchAllUsersAsync, fetchUserPrivilegesAsync, getPrivilegeTypes, removePrivilege, updatePrivilegeAsync, assignRolePrivilegeAsync } from "../thunks/PrivilegeThunk";


const privilegeSlice = createSlice({
  name: "Privilege",
  initialState: {
    privilegeTypes: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      // Create Privilege
      .addCase(createPrivilegeAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createPrivilegeAsync.fulfilled, (state, action) => {
        state.privilegeTypes.push({
          id: action.payload.id,
          section: action.payload.section,
          name: action.payload.name,
          description: action.payload.description,
          isGranted: action.payload.isGranted
        }); // Add new privilege
        state.loading = false;
      })
      .addCase(createPrivilegeAsync.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })
      // Fetch Privilege Types
      .addCase(getPrivilegeTypes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPrivilegeTypes.fulfilled, (state, action) => {
        state.loading = false;
        state.privilegeTypes = action.payload;
      })
      .addCase(getPrivilegeTypes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Update Privilege
      .addCase(updatePrivilegeAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updatePrivilegeAsync.fulfilled, (state, action) => {
        const index = state.privilegeTypes.findIndex(
          (item) => item.id === action.payload.id
        );
        if (index !== -1) {
          state.privilegeTypes[index] = action.payload;
        }
        state.loading = false;
      })
      .addCase(updatePrivilegeAsync.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })
      .addCase(removePrivilege.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(removePrivilege.fulfilled, (state, action) => {
        state.loading = false;
        state.privilegeTypes = state.privilegeTypes.filter(
          (p) => p.id !== action.payload
        );
      })
      .addCase(removePrivilege.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
       .addCase(fetchAllUsersAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllUsersAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload || [];
      })
      .addCase(fetchAllUsersAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchUserPrivilegesAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserPrivilegesAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.userPrivileges = action.payload || [];
      })
      .addCase(fetchUserPrivilegesAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
       .addCase(assignUserPrivilegeAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(assignUserPrivilegeAsync.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(assignUserPrivilegeAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
        .addCase(assignRolePrivilegeAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(assignRolePrivilegeAsync.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(assignRolePrivilegeAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });

  },
});

export default privilegeSlice.reducer;

